<template>
  <div class="layout" style="width:100%">
    <div :class="style">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import "@/assets/css/style.css";
import { systemmessage } from "../../assets/js/url";

export default {
  name: "layout",
  data() {
    return {
      show: true
    };
  },
  provide() {
    return {
      // reload: this.reload
    };
  },
  mounted() {
    this.htmlfonsize();
    // this.getsystemmessagee();
    const _this = this;
    // window.addEventListener("popstate", function() {
    //   $(".dw-modal").remove();
    //   _this.show = false;
    //   _this.$nextTick(function() {
    //     _this.show = true;
    //   });
    // });
  },
  computed: {
    style() {
      if (window.localStorage.getItem("COLOR")) {
        if (
          this.$store.state.cssstyle != window.localStorage.getItem("COLOR")
        ) {
          this.$store.commit(
            "changestyle",
            window.localStorage.getItem("COLOR")
          );
        }
      }
      if (this.$store.state.cssstyle == "black") {
        $("body").css({ background: "#000f18", color: "#c8c8c8" });
      } else {
        $("body").css({ background: "#ffffff", color: "#666" });
      }
      return this.$store.state.cssstyle;
    }
  },
  methods: {
    reload() {
      const _this = this;
      _this.show = false;
      _this.$nextTick(function() {
        _this.show = true;
      });
    },
    htmlfonsize() {
      //移动端文字自适应，在iphone6 宽度375下，1rem = 10px
      function fixRem() {
        const windowWidth =
          document.documentElement.clientWidth ||
          window.innerWidth ||
          document.body.clientWidth;
        // windowWidth = windowWidth > 750 ? 750 : windowWidth;
        // const rootSize = 100 * ((windowWidth > 750 ? 750 : windowWidth) / 375)
        const rootSize = 100;
        const htmlNode = document.getElementsByTagName("html")[0];
        htmlNode.style.fontSize = rootSize + "px";
      }

      fixRem();
      window.addEventListener("resize", fixRem, false);
    },
    getsystemmessagee() {
      this.$http.post(systemmessage).then(res => {
        let serverurl = null;
        res.data.data.forEach(item => {
          if (item.sys_id == "serverurl") {
            serverurl = item.sys_val;
          }
        });
        const check = res.data.data.some((item, index) => {
          return item.sys_id == "mediasuite";
        });
        this.$store.commit("setserverurl", serverurl);
        if (check) {
          this.$store.commit("sethasmediasuite", true);
        } else {
          this.$store.commit("sethasmediasuite", false);
        }
      });
    }
  }
};
</script>
<style>
* {
  margin: 0px;
  padding: 0px;
  font-family: "微软雅黑", sans-serif;
}

body {
  color: #666;
}

ul,
li {
  list-style: none;
}

input::-webkit-input-placeholder {
        color: #ddd;
      }
  #meetingIntroTextarea textarea.ivu-input {
  border:0 !important;
  padding-left: 0;
}
  #meetingIntroTextarea textarea.ivu-input:focus {
    box-shadow: none;
  }
  #meetingChooseModal .ivu-select-selection,
  #meetingChooseType .ivu-select-selection {
  border:0;
  /* color:#ddd; */
  padding-left: 0;
}
  #meetingChooseModal .ivu-select-placeholder,
  #meetingChooseType .ivu-select-placeholder {
    padding-left: 0;
    color:#ddd;
    font-size: inherit;
  }
  #meetingChooseModal .ivu-select-selection:focus,
  #meetingChooseType .ivu-select-selection:focus   {
  box-shadow:none;
}

.slide-right-enter-active,
.slide-right-leave-active {
  will-change: transform;
  transition: all 100ms;
  position: absolute;
}

.slide-right-enter {
  opacity: 1;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 1;
  transform: translate3d(100%, 0, 0);
}

.list .ivu-checkbox {
  float: right;
  height: 0.56rem;
  line-height: 0.56rem;
  margin-left: 0.06rem;
  font-size: 0.14rem;
}

.list .ivu-radio {
  float: right;
  transform: translateY(120%);
  margin-left: 0.06rem;
}
.ivu-radio-wrapper > span {
  font-size: 0.14rem !important;
}

.ivu-checkbox-wrapper > span {
  font-size: 0.14rem !important;
}

.ivu-input {
  background-color: transparent !important;
}

.ivu-select-selection {
  background-color: transparent !important;
}

a {
  color: #666 !important;
}

.black a {
  color: #c8c8c8 !important;
}

.acolor {
  color: #666 !important;
}

.black .acolor {
  color: #c8c8c8 !important;
}
.ivu-select-item {
  width: 200px;
}
#timePickerLong .ivu-input,
#timePickerLong .ivu-input:focus {
  border:0;
  box-shadow: none;;
}
.ivu-time-picker-cells-list {
  overflow: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/layout.vue